import { Switchboard } from "../../lib/events";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class KmlDownloadButton extends ToolbarButton {
    constructor(layer) {
        super('download', 'Download KML for Selected Parcels', 'kmlDownloadButton');
        this.layer = layer;
        this.selection_receiver = Switchboard.get_receiver("SELECTION");
        this.selection_receiver.on('change', () => {
            if (!this.layer.features.length) {
                this.ui.prop("disabled", true);
            }
            else {
                this.ui.prop("disabled", false);
            }
        });
        if (!this.layer.features.length) {
            this.ui.prop("disabled", true);
        }
    }
    _action() {
        this.layer.downloadKml();
    }
}
